module.exports = __webpack_public_path__ + "static/media/Collection_CSO_Block.d30397d9.svg";